export default __webpack_public_path__ + "static/media/image4.5b871fd2.jpeg";